export default "__VITE_ASSET__CbUff4MD__"